export const NotQualifiedIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <g clip-path="url(#clip0_839_853)">
            <path d="M9.91667 6.41667V7.58333H4.08333V6.41667H9.91667ZM14 7C14 10.8599 10.8599 14 7 14C3.14008 14 0 10.8599 0 7C0 3.14008 3.14008 0 7 0C10.8599 0 14 3.14008 14 7ZM11.0833 6.41667C11.0833 5.77325 10.5601 5.25 9.91667 5.25H4.08333C3.43992 5.25 2.91667 5.77325 2.91667 6.41667V7.58333C2.91667 8.22675 3.43992 8.75 4.08333 8.75H9.91667C10.5601 8.75 11.0833 8.22675 11.0833 7.58333V6.41667Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_839_853">
            <rect width="14" height="14" fill="white"/>
            </clipPath>
        </defs>
        </svg>
    `,
      }}
    />
  );
};
